export enum ShoalNeighborType {
  Sea = 1,
  Shoal = 2,
  Land = 3,
}